import { formValueSelector } from 'redux-form';
export const getContactEmail = (form, state) => formValueSelector(form)(state, 'contactInformation.email');
//# sourceMappingURL=travelerContacts.js.map